// extracted by mini-css-extract-plugin
module.exports = {"row":"Table_row__S40Im","alternaterow":"Table_alternaterow__3dmqL"};